import React, { ReactNode } from 'react';
import { IoCloseCircle as ErrorIcon } from 'react-icons/io5';

interface Props {
  title: ReactNode;
  errors: ReactNode[];
  onClose?: () => void;
}

export const FormAlert = ({ title, errors, onClose }: Props) => {
  return (
    <div className="rounded-md bg-red-50 p-4">
      <div className="flex">
        <div className="flex-shrink-0">
          {/* Heroicon name: solid/x-circle */}
          <ErrorIcon role={'button'} onClick={onClose} className="h-5 w-5 text-red-400" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-red-800">{title}</h3>
          <div className="mt-2 text-sm text-red-700">
            {errors.length > 1 ? (
              <ul className="list-disc pl-5 space-y-1">
                {errors.map((error) => (
                  <li key={error?.toString()}>{error}</li>
                ))}
              </ul>
            ) : (
              errors[0]
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
